import {ElementLabel, getElementsData} from '../incase-domain/elements/base/elementsData';
import {
    baseElementTypes,
    ELEMENT,
    formsElementTypes,
    mediaElementTypes,
    otherElementTypes,
    shapeElementTypes,
} from '../incase-domain/elements/base/ElementTypes';

export const questionElementTypes = [
    ELEMENT.QUESTION,
    ELEMENT.YES_NO_QUESTION_V2,
    ELEMENT.MULTI_SELECT,
    ELEMENT.PHOTO_ANSWER_QUESTION,
    ELEMENT.IMAGE_MARKUP,
    ELEMENT.SEQUENCE_QUESTION,
    ELEMENT.MATCH_PAIR_QUESTION,
    ELEMENT.LIKERT_SCALE,
    ELEMENT.QUESTION_REPORT,
];

export type ElementType = {
    icon: string;
    label: ElementLabel;
    type: ELEMENT;
    elementProps?: Record<string, unknown>;
    shortcut?: string[];
};

export type ElementGroupLabel = 'basic' | 'forms' | 'media' | 'questions' | 'shapes' | 'other';

type ElementsGroupType = {
    label: ElementGroupLabel;
    icon: string;
    items: ElementType[];
}[];

export function editSidebarGroupTranslationKey(label: ElementGroupLabel): `presEditPage.editSidebar.${ElementGroupLabel}` {
    return `presEditPage.editSidebar.${label}` as const;
}

export function editSidebarElementTranslationKey(label: ElementLabel): `presEditPage.editSidebar.elements.${ElementLabel}` {
    return `presEditPage.editSidebar.elements.${label}` as const;
}

export function menuBarInsertGroupTranslationKey(label: ElementGroupLabel): `menuBar.insertMenu.${ElementGroupLabel}` {
    return `menuBar.insertMenu.${label}` as const;
}

export function menuBarInsertElementTranslationKey(label: ElementLabel): `menuBar.insertMenu.element.${ElementLabel}` {
    return `menuBar.insertMenu.element.${label}` as const;
}

export const elementGroups: ElementsGroupType = [
    {
        label: 'basic',
        icon: 'mynaui:type-text',
        items: getElementsData(baseElementTypes),
    },
    {
        label: 'forms',
        icon: 'solar:text-field-focus-linear',
        items: getElementsData(formsElementTypes),
    },
    {
        label: 'media',
        icon: 'solar:gallery-minimalistic-linear',
        items: getElementsData(mediaElementTypes),
    },
    {
        label: 'questions',
        icon: 'mynaui:question-hexagon',
        items: getElementsData(questionElementTypes),
    },
    {
        label: 'shapes',
        icon: 'solar:stop-linear',
        items: getElementsData(shapeElementTypes),
    },
    {
        label: 'other',
        icon: 'solar:calculator-linear',
        items: getElementsData(otherElementTypes),
    },
];
